import React from 'react';

const OrderItemsTable = ({ order }) => (
  <table className="w-full text-sm">
    <thead>
      <tr className="text-gray-500">
        <th className="text-left py-1">商品</th>
        <th className="text-right py-1">单价</th>
        <th className="text-right py-1">数量</th>
        <th className="text-right py-1">小计</th>
      </tr>
    </thead>
    <tbody>
      {order.items && order.items.map(item => (
        <tr key={item.id} className="border-t border-gray-100">
          <td className="py-2">{item.product_name}</td>
          <td className="text-right py-2">${parseFloat(item.unit_price).toFixed(2)}</td>
          <td className="text-right py-2">x{item.quantity}</td>
          <td className="text-right py-2">${parseFloat(item.subtotal).toFixed(2)}</td>
        </tr>
      ))}
    </tbody>
    <tfoot>
      <tr className="border-t border-gray-200">
        <td colSpan="3" className="py-2 text-gray-500">配送费</td>
        <td className="text-right py-2">${parseFloat(order.delivery_fee || 0).toFixed(2)}</td>
      </tr>
      <tr className="font-semibold">
        <td colSpan="3" className="py-2">合计</td>
        <td className="text-right py-2">${parseFloat(order.total_amount).toFixed(2)}</td>
      </tr>
    </tfoot>
  </table>
);

export default OrderItemsTable;